export default defineAppConfig({
  ui: {
    primary: 'azure-radiance',
    gray: 'neutral',
    notifications: {
      position: 'top-0 right-0',
    },
  },
})
